import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
import { MascotPanel } from '../ui/MascotPanel';
import { PlusIcon, XIcon } from 'lucide-react';
export function Step12Tech() {
  const {
    data,
    updateData
  } = useIntake();
  const [newDomain, setNewDomain] = useState('');
  const addDesiredDomain = () => {
    if (newDomain.trim()) {
      updateData({
        desiredDomains: [...data.desiredDomains, newDomain.trim()]
      });
      setNewDomain('');
    }
  };
  const removeDesiredDomain = (index: number) => {
    updateData({
      desiredDomains: data.desiredDomains.filter((_, i) => i !== index)
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-52">
      <MascotPanel message="Bijna klaar! Nog even wat praktische zaken rondom domeinnamen en hosting." data-id="element-53" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-54">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-55">Techniek & Hosting</h2>

        <div data-id="element-56">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-57">
            Heeft u al een domeinnaam geregistreerd? (bijv. www.uwbedrijf.nl)
          </label>
          <RadioGroup columns={2} value={data.domainOwned} onChange={val => updateData({
          domainOwned: val
        })} options={[{
          value: 'yes',
          label: 'Ja, ik heb al een domeinnaam'
        }, {
          value: 'no',
          label: 'Nee, deze moet nog geregistreerd worden'
        }]} data-id="element-58" />
        </div>

        <AnimatePresence data-id="element-59">
          {data.domainOwned === 'yes' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 pt-4 border-t border-gray-100 overflow-hidden" data-id="element-60">
              <Input label="Welk domein is dit?" placeholder="bijv. www.mijnbedrijf.nl" value={data.domainName} onChange={e => updateData({
            domainName: e.target.value
          })} data-id="element-61" />

              <Input label="Waar is deze gehost?" placeholder="bijv. TransIP, Hostnet..." value={data.domainHost} onChange={e => updateData({
            domainHost: e.target.value
          })} data-id="element-62" />

              <div data-id="element-63">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-64">
                  Beheert u dit zelf of via een 3e partij?
                </label>
                <RadioGroup columns={2} value={data.domainManagement} onChange={val => updateData({
              domainManagement: val
            })} options={[{
              value: 'self',
              label: 'Ik beheer dit zelf'
            }, {
              value: 'third_party',
              label: 'Via een 3e partij'
            }]} data-id="element-65" />
              </div>

              {data.domainManagement === 'third_party' && <Input label="Welke 3e partij?" placeholder="Naam van de partij of contactpersoon" value={data.domainThirdParty} onChange={e => updateData({
            domainThirdParty: e.target.value
          })} data-id="element-66" />}
            </motion.div>}

          {data.domainOwned === 'no' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-4 pt-4 border-t border-gray-100 overflow-hidden" data-id="element-67">
              <label className="block text-sm font-semibold text-gray-900" data-id="element-68">
                Welke domeinnaam wilt u registreren?
              </label>
              <p className="text-sm text-gray-500" data-id="element-69">
                U kunt meerdere domeinnamen opgeven als u twijfelt of meerdere
                wilt reserveren.
              </p>

              {data.desiredDomains.length > 0 && <div className="flex flex-wrap gap-2" data-id="element-70">
                  {data.desiredDomains.map((domain, index) => <div key={index} className="flex items-center bg-[#F0F7FF] border border-[#007AFF]/20 rounded-full px-3 py-1.5" data-id="element-71">
                      <span className="text-sm font-medium text-[#007AFF]" data-id="element-72">
                        {domain}
                      </span>
                      <button onClick={() => removeDesiredDomain(index)} className="ml-2 p-0.5 text-[#007AFF] hover:text-red-500 transition-colors" data-id="element-73">
                        <XIcon className="w-3.5 h-3.5" data-id="element-74" />
                      </button>
                    </div>)}
                </div>}

              <div className="flex gap-3" data-id="element-75">
                <div className="flex-1" data-id="element-76">
                  <Input placeholder="bijv. www.mijnbedrijf.nl" value={newDomain} onChange={e => setNewDomain(e.target.value)} onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  addDesiredDomain();
                }
              }} data-id="element-77" />
                </div>
                <Button variant="outline" onClick={addDesiredDomain} className="flex-shrink-0" data-id="element-78">
                  <PlusIcon className="w-5 h-5" data-id="element-79" />
                </Button>
              </div>
            </motion.div>}
        </AnimatePresence>

        <div data-id="element-80">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-81">
            Hoe wilt u de hosting en het onderhoud regelen?
          </label>
          <RadioGroup columns={1} value={data.hostingActive} onChange={val => updateData({
          hostingActive: val
        })} options={[{
          value: 'noord',
          label: 'Volledig ontzorgd via Noord Digital (Aanbevolen)',
          description: 'Inclusief updates, back-ups, beveiliging en support'
        }, {
          value: 'external',
          label: 'Ik regel zelf externe hosting',
          description: 'Let op: dit vereist extra configuratiewerk'
        }]} data-id="element-82" />

          <AnimatePresence data-id="element-83">
            {data.hostingActive === 'external' && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="mt-4 overflow-hidden" data-id="element-84">
                <div className="p-4 bg-amber-50 border-l-4 border-amber-400 rounded-r-xl" data-id="element-85">
                  <p className="text-sm text-amber-800" data-id="element-86">
                    <strong data-id="element-87">Let op:</strong> Als u de hosting zelf regelt,
                    rekenen wij <strong data-id="element-88">10% extra kosten</strong> op het
                    totaalbedrag in verband met extra afstemming en technische
                    complexiteit.
                  </p>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </motion.div>;
}